/* istanbul ignore file */

import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { CardMode } from '@components/card/card.component';
import { MdsTextFieldComponent } from '@medpacesoftwaredevelopment/designsystem';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { FormGroupValueOf } from '@utility/utility';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';
export class TrainPreferencesFormGroup extends PersistentFormGroup<{
    specialNeeds: PersistentFormControl<string>;
}> {
    public static create(value: FormGroupValueOf<TrainPreferencesFormGroup>): TrainPreferencesFormGroup {
        return new TrainPreferencesFormGroup({
            specialNeeds: new PersistentFormControl(value.specialNeeds, [
                notWhitespaceValidator(),
                maxLengthValidator(500),
            ]),
        });
    }
}
@Component({
    selector: 'medpace-train-preferences',
    templateUrl: './train-preferences.component.html',
    styleUrls: ['./train-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MdsTextFieldComponent],
})
export class TrainPreferencesComponent {
    public readonly formGroup: InputSignal<TrainPreferencesFormGroup> = input.required<TrainPreferencesFormGroup>();
    public readonly mode: InputSignal<CardMode> = input.required<CardMode>();
}
